import { MetaPropertySchema } from './metaPropertySchema';

export class User {
	id: number;
	username: string;
	first_name: string;
	name: string;
	NIT: string;
	DUI: string;
	phone: string;
	address: string;
	primary_email: string;
	password: string;
	roles: Array<any>;
	properties: Array<MetaPropertySchema>; // the new way
	// getters
	get fullName(): string {
		if (this.first_name) {
			return this.first_name + ' ' + this.name;
		}
        return this.name;
	};
}